<template>
  <section id="users">
    <h3 class="panel-title">{{ $t('panel.dashboard.leaderboards') }}</h3>
    <!-- No server endpoint aggregates tickets or activity per user yet, so there is nothing real to list. -->
    <div class="card text-center text-light" style="background-color: var(--gh-surface-raised);">
      <div class="card-body py-4">
        <i class="fas fa-users fa-2x mb-2 text-muted" aria-hidden="true"></i>
        <p class="mb-0 text-muted">{{ $t('panel.dashboard.noDataYet') }}</p>
      </div>
    </div>
  </section>
</template>
